import React from "react";
import classNames from "classnames";
import { Icons } from "prefab";
import cardstyles from "../../../../../styles/InfoBlock.module.scss";
import contactstyles from "../../../../../styles/InfoBlock.module.scss";
import Card from "../../../../common/InfoBlock/Card";
import trackingElement from "../../../../common/TrackingElement";

const { CallIcon, EmailAddressIcon } = Icons;

const ContactWithTracking = ({ name, type, phone, email }) => {
  const isName = name && (name.old || name.new);
  const isPhone = phone && (phone.old || phone.new);
  const isEmail = email && (email.old || email.new);
  return isName || isPhone || isEmail ? (
    <Card md={6} className={classNames(cardstyles.contactCardList)}>
      <div className={contactstyles.contactContainer}>
        {isName && (
          <>
            <div className={contactstyles.title}>{trackingElement(name)}</div>
            <div className={contactstyles.subTitle}>{trackingElement(type)}</div>
          </>
        )}
        {isPhone && (
          <div className={contactstyles.contactInfo}>
            <CallIcon />
            <span>{trackingElement(phone)}</span>
          </div>
        )}
        {isEmail && (
          <div className={contactstyles.contactInfo}>
            <EmailAddressIcon />
            <span>{trackingElement(email)}</span>
          </div>
        )}
      </div>
    </Card>
  ) : null;
};

export default ContactWithTracking;
